import { Fragment, useState } from "react";
import {
	Box,
	Button,
	Container,
	FilledInput,
	FormControl,
	InputLabel,
	Typography,
} from "@mui/material";
import { styled } from "@mui/styles";
import Swal from "sweetalert2";
import REGEX from "../../utils/regex/regex";
import "./CheckoutBuyerForm.css";

const CheckoutFormControl = styled(FormControl)(({ theme }) => ({
	marginBottom: ".8rem",
	width: "100%",
	"& .MuiInputLabel-root.Mui-focused": {
		color: theme.palette.light.main,
	},
}));

const CheckoutBuyerForm = ({
	buyerForm,
	setBuyerForm,
	handleSubmit,
	register,
	errors,
}) => {
	const [edit, setEdit] = useState(false);

	const toggleEdit = () => {
		setEdit(!edit);
	};

	const handleEdit = (data) => {
		setBuyerForm({ ...buyerForm, ...data });
		toggleEdit();
	};

	const handleModifyData = (event) => {
		Swal.fire({
			customClass: {
				confirmButton: "swalBtnOkChangeData",
				// cancelButton: "swalBtnCancelChangeData",
				title: "swalTitleCkout",
				// container: "swalTextSize",
			},
			position: "left",
			icon: "question",
			title: "Los datos se modificarán sólo para éste pedido.",
			width: "350px",
			showConfirmButton: true,
			// showCancelButton: true,
			confirmButtonText: "Aceptar",
			// cancelButtonText: "Volver",
			focusConfirm: false,
			iconColor: "#e60b13",
			color: "#292929",
			background: "#FAFAFA",
			cancelButtonColor: "#292929",
		}).then((result) => {
			if (result.value) {
				// api para modificar datos
			} else {
				return;
			}
		});
	};

	return (
		<Fragment>
			<Container
				sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
			>
				<Box display="flex" justifyContent="space-between">
					<Typography
						variant="subtitle1"
						color={(theme) => theme.palette.light.main}
						sx={{
							fontSize: "1rem",
						}}
					>
						Datos de facturación:
					</Typography>
					<Box onClick={toggleEdit} sx={{ cursor: "pointer" }}>
						<Typography
							variant="subtitle1"
							color={(theme) => theme.palette.light.main}
							sx={{
								fontSize: "1rem",
							}}
						>
							Modificar
						</Typography>
					</Box>
				</Box>
			</Container>
			<Container sx={{ marginTop: "1rem", marginBottom: "1rem" }}>
				{!edit ? (
					<Fragment>
						<Typography
							variant="subtitle1"
							sx={{
								fontSize: "1.1rem",
							}}
						>
							{buyerForm.clientName}
						</Typography>
						<Typography
							variant="subtitle1"
							color={(theme) => theme.palette.light.main}
							sx={{
								fontSize: "1rem",
							}}
						>
							CUIT: {buyerForm.clientCuit}
						</Typography>
					</Fragment>
				) : (
					<Fragment>
						<Box
							component="form"
							onSubmit={handleSubmit((data) => handleEdit(data))}
						>
							<CheckoutFormControl fullWidth>
								<InputLabel>Nombre y Apellido</InputLabel>
								<FilledInput
									type="text"
									{...register("clientName", {
										required: "Debe completar este campo",
									})}
									defaultValue={buyerForm.clientName}
									variant=""
								></FilledInput>
								{errors.clientName ? (
									<Typography variant="caption" color="error">
										{errors.clientName.message}
									</Typography>
								) : (
									<Typography variant="caption" sx={{ color: "#FAFAFA" }}>
										<br />
									</Typography>
								)}
							</CheckoutFormControl>
							<CheckoutFormControl fullWidth>
								<InputLabel>Razón Social</InputLabel>
								<FilledInput
									type="text"
									{...register("clientBusinessName", {
										required: "Debe completar este campo",
									})}
									variant=""
									defaultValue={buyerForm.clientCuit}
								></FilledInput>
								{errors.clientBusinessName ? (
									<Typography variant="caption" color="error">
										{errors.clientBusinessName.message}
									</Typography>
								) : (
									<Typography variant="caption" sx={{ color: "#FAFAFA" }}>
										<br />
									</Typography>
								)}
							</CheckoutFormControl>
							<CheckoutFormControl>
								<InputLabel>Teléfono</InputLabel>
								<FilledInput
									type="number"
									{...register("clientPhone", {
										required: "Debe completar este campo",
										valueAsNumber: "Debe ingresar solo números",
									})}
									defaultValue={buyerForm.clientPhone}
								></FilledInput>
								{errors.clientPhone ? (
									<Typography variant="caption" color="error">
										{errors.clientPhone.message}
									</Typography>
								) : (
									<Typography variant="caption" sx={{ color: "#FAFAFA" }}>
										<br />
									</Typography>
								)}
							</CheckoutFormControl>
							<CheckoutFormControl>
								<InputLabel>Email</InputLabel>
								<FilledInput
									type="text"
									{...register("clientEmail", {
										required: "Debe completar este campo",
										pattern: {
											value: REGEX.emailFormatValidator,
											message: "Formato email invalido. tuemail@email.com",
										},
									})}
									defaultValue={buyerForm.clientEmail}
								></FilledInput>
								{errors.clientEmail ? (
									<Typography variant="caption" color="error">
										{errors.clientEmail.message}
									</Typography>
								) : (
									<Typography variant="caption" sx={{ color: "#FAFAFA" }}>
										<br />
									</Typography>
								)}
							</CheckoutFormControl>
							{/* <CheckoutFormControl>
								<InputLabel>CUIT</InputLabel>
								<FilledInput
									type="number"
									{...register("clientCuit", {
										required: "Debe completar este campo",
										pattern: {
											value: REGEX.cuitFormatValidator,
											message: "El CUIT debe contener 11 caracteres",
										},
									})}
								></FilledInput>
								{errors.clientCuit ? (
									<Typography variant="caption" color="error">
										{errors.clientCuit.message}
									</Typography>
								) : (
									<Typography variant="caption" sx={{ color: "#FAFAFA" }}>
										<br />
									</Typography>
								)}
							</CheckoutFormControl> */}
							<Button
								type="sumbit"
								color="secondary"
								variant="contained"
								fullWidth
								sx={{ textTransform: "capitalize", marginTop: "1rem" }}
								onClick={handleModifyData}
							>
								Confirmar datos
							</Button>
						</Box>
					</Fragment>
				)}
			</Container>
		</Fragment>
	);
};

export default CheckoutBuyerForm;
